import { render, staticRenderFns } from "./TopDetailInfo.vue?vue&type=template&id=73ed431a&scoped=true&"
import script from "./TopDetailInfo.vue?vue&type=script&lang=ts&"
export * from "./TopDetailInfo.vue?vue&type=script&lang=ts&"
import style0 from "./TopDetailInfo.vue?vue&type=style&index=0&id=73ed431a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73ed431a",
  null
  
)

export default component.exports